import styled from 'styled-components';

const WindcreekTabs = styled.div`
  background-color: ${props => props.theme.tabs.backgroundColor};
  height: 100%;
  flex: 1 0 auto;
  display: flex;
  justify-content: space-around;
`;

export default WindcreekTabs;
